import { render, staticRenderFns } from "./FilterRule.vue?vue&type=template&id=4997b189&scoped=true&"
import script from "./FilterRule.vue?vue&type=script&lang=js&"
export * from "./FilterRule.vue?vue&type=script&lang=js&"
import style0 from "./FilterRule.vue?vue&type=style&index=0&id=4997b189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997b189",
  null
  
)

export default component.exports